import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

export const WarningTextField = ({ value }) => {
  const [purify, setPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      setPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!purify.sanitize) return null;

  return (
    <div className="warning-text-field">
      <Icon className="warning-text-field__icon" name="warning" />
      <div
        className="warning-text-field__text"
        dangerouslySetInnerHTML={{ __html: purify.sanitize(value) }}
      />
    </div>
  );
};

WarningTextField.propTypes = {
  value: PropTypes.string.isRequired,
};
